
export default {
  devStoreConfig: true,
  mockdata: {
    loginUsername: 'administrator',
    loginPassword: 'kodikos'
  },
  plugin: {
    backgroundDashboardRefreshInterval: 60 * 1000,
  },
  disableChecklistMode: false,
  showStrategy: true,
};




// WEBPACK FOOTER //
// ./config/config.development.js